import { SubscriptionTypes } from "component-library";
import { useTranslation } from "i18n";

interface Props {
  fromPlan: SubscriptionTypes;
  toPlan: SubscriptionTypes;
}

const ReinstateOriginalPlanModalHeader = ({ fromPlan, toPlan }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <p className="text-[18px] font-medium leading-[23px]">
        <strong>
          {t(
            "performer:accountSettings.mySubscriptionPage.reinstateOriginalPlanModal.changeRequested"
          )}
        </strong>
      </p>

      <div className="py-[20px] border-b border-b-[bg-grey-medium-3]">
        <p>
          <strong className="mr-[20px]">
            {t(
              "performer:accountSettings.mySubscriptionPage.reinstateOriginalPlanModal.from"
            )}
          </strong>
          {fromPlan}
        </p>
        <p>
          <strong className="mr-[20px]">
            {t(
              "performer:accountSettings.mySubscriptionPage.reinstateOriginalPlanModal.to"
            )}
          </strong>
          {toPlan}
        </p>
      </div>
    </>
  );
};

export default ReinstateOriginalPlanModalHeader;
